var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('notification', {
    attrs: {
      "active": _vm.active,
      "message": _vm.message
    },
    on: {
      "close": _vm.hide
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb057166","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/notification/Notification/NotificationContainer.vue
// module id = 1219
// module chunks = 0